import ArrayInput from "./ArrayInput";
import DateInput from "./DateInput";
import NumberInput from "./NumberInput";
import ObjectInput from "./ObjectInput";
import StringInput from "./StringInput"

export interface InputProps {
    fromArray?: boolean
    hasParent?: boolean
    content: any
    required: boolean
    value?: any
    onChange: (value: any) => void
}

export default function Input(props: InputProps) {
    switch(props.content.type) {
        case "string":
            return <StringInput {...props}></StringInput>;
        case "date":
            return <DateInput {...props}></DateInput>;
        case "array":
            return <ArrayInput {...props}></ArrayInput>;
        case "object":
            return <ObjectInput {...props}></ObjectInput>;
        case "number":
            return <NumberInput {...props}></NumberInput>;  
        default:
            throw "unknown schema type " + props.content.type         
    }
    return <></>   
}